module.exports = __webpack_public_path__ + "static/habit-tracker-4841bd0f21737b83d176523afbfdb6b8.png";